import { z } from "zod";
import { normalizeClarityOneOtpPhone } from "./customerPhoneIdentity";
import { parsePhoneNumberFromString } from "libphonenumber-js";

export function normalizeReceiptContact(channel: "email" | "whatsapp", raw: string): string | null {
  const value = raw.trim();
  if (channel === "email") return z.string().max(320).email().safeParse(value).success ? value.toLowerCase() : null;
  if (value.length > 50 || !/^[+\d\s().-]+$/.test(value)) return null;
  const normalized = normalizeClarityOneOtpPhone(value);
  return normalized && parsePhoneNumberFromString(normalized, "SG")?.isValid() ? normalized : null;
}
